import React from 'react';
import { NavRailSubmenuItem } from '../../../components/layout/NavRailExpandableSection';
import { buildToolkitTools } from './ToolkitMenuContent';

const TOOLKIT_LABELS = {
  feeding: 'Feed tracker',
  area: 'Planting',
  'printable-map': 'Printable map',
};

export function ToolkitNavSubmenu({
  onOpenFeedManagement,
  onOpenPlantingAssistant,
  onOpenPrintableMap,
}) {
  const tools = buildToolkitTools({
    onOpenFeedManagement,
    onOpenPlantingAssistant,
    onOpenPrintableMap,
  });

  return tools.map((tool) => (
    <NavRailSubmenuItem
      key={tool.id}
      icon={tool.icon}
      label={TOOLKIT_LABELS[tool.id] || tool.title}
      tooltip={tool.disabled ? `${tool.title} (coming soon)` : tool.title}
      disabled={tool.disabled}
      onClick={() => {
        if (tool.disabled || !tool.onClick) return;
        tool.onClick();
      }}
    />
  ));
}
